const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const formatDate = (datestr) => {
  const date = new Date(datestr);
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Function to get the ordinal suffix for the day
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // 11th-13th are exceptions
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const ordinalSuffix = getOrdinalSuffix(day);

  return `${month} ${day}${ordinalSuffix} ${year}`;
};

export const getDateRange = (start_date, end_date) => {
  const start = new Date(start_date);
  const end = new Date(end_date);

  // Check if start date is the same as end date
  if (start.getTime() === end.getTime()) {
    return formatDate(start_date);
  }

  const startMonth = months[start.getMonth()];
  const endMonth = months[end.getMonth()];

  if (startMonth === endMonth && start.getFullYear() === end.getFullYear()) {
    const startDate = formatDate(start_date).split(' ')[1];
    const endDate = formatDate(end_date).split(' ')[1];
    return `${startDate} to ${endDate} ${endMonth} ${end.getFullYear()}`;
  } else {
    const startDate = formatDate(start_date);
    const endDate = formatDate(end_date);
    return `${startDate} to ${endDate}`;
  }
};

export const formatTime = (datestr) => {
  const date = new Date(datestr);
  return `${date.getHours()}:${date.getUTCMinutes().toString().padStart(2, "0")}`;
};

export const getToday = () => {
  const today = new Date();
  const day = today.getDate().toString().padStart(2, "0");
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};
